import React, { useRef, useState, useCallback } from "react";
import TagCloudCategory from "./TagCloudCategory";
import { Content } from "@jobber/components/Content";
import { Card } from "@jobber/components/Card";
import { Button } from "@jobber/components/Button";

function Offcanvas({
  tagCloudCategoryHandler,
  tagCloudCategory,
  tagCategoryReload,
  setTagCategoryReload,
}) {
  const dropdownRef = useRef(null);
  const [isPageLoad, setPageLoad] = useState(true);
  const [width, setWidth] = useState(400);
  const [isHovered, setIsHovered] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const startResizing = useCallback((mouseDownEvent) => {
    mouseDownEvent.preventDefault();
    setIsResizing(true);

    const onMouseMove = (mouseMoveEvent) => {
      const newWidth = window.innerWidth - mouseMoveEvent.clientX;
      const maxWidth = window.innerWidth * 0.75;
      if (newWidth > 300 && newWidth < maxWidth) {
        setWidth(newWidth);
      }
    };

    const onMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }, []);

  return (
    <div
      className={`offcanvas offcanvas-end ${tagCloudCategory ? "show" : ""}`}
      style={{
        overflowX: 'hidden',
        width: `${width}px`,
        transition: isResizing ? "none" : "width 0.3s ease",
      }}
      ref={dropdownRef}
      data-backdrop="static"
      tabIndex="-1"
    >
      <div
        onMouseDown={startResizing}
        onDoubleClick={() => setWidth(400)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "5px",
          cursor: "ew-resize",
          zIndex: 1000,
          backgroundColor: isHovered ? "rgba(0, 0, 0, 0.1)" : "transparent",
          transition: "background-color 0.2s ease",
        }}
      />
      <div className="offcanvas-body" style={{
        overflowX: 'hidden',
        overflowY: "scroll",
      }}>
        <Card
          header={{
            title: "Tag Cloud Category",
            action: <Button label="X" onClick={tagCloudCategoryHandler} />,
          }}
        >
          <Content>
            {tagCategoryReload ? (
              <TagCloudCategory
                key={tagCloudCategory ? "open" : "closed"}
                isPageLoad={isPageLoad}
                setPageLoad={setPageLoad}
                tagCloud={tagCloudCategory}
                reload={() => {
                  setTagCategoryReload(false);
                  setTimeout(() => {
                    setTagCategoryReload(true);
                  }, 1);
                }}
              />
            ) : (
              ""
            )}
          </Content>
        </Card>
      </div>
    </div>
  );
}

export default Offcanvas;
